// @flow

import * as React from 'react';
import { observer } from 'mobx-react';
import { Row, Col, Button, FormGroup, Label, Input, FormText } from 'reactstrap';

type Props = {
  entity: any,
  field: string,
  trim?: boolean,
};

@observer
export default class StringDataTableEntry extends React.Component<Props, void> {
  
  static defaultProps = {
    trim: false,
    disabled: false
  };
  
  render() {
    const { entity, field } = this.props;
    const value = entity[field];
    
    if (value) {
      return (value);
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/App/Components/StringDataTableEntry.js